import { createAsyncThunk } from "@reduxjs/toolkit";
import { DataService } from "../config/dataService/dataService";

export const fetchAllCodBank = createAsyncThunk(
    "cod-bank/fetch",
    async (filter, { rejectWithValue }) => {
        try {
            let url = '/cod-bank'
            if (filter && filter !== '') {
                url += '?' + filter;
            }

            const response = await DataService.get(url);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }  
)

export const createNewCodBank = createAsyncThunk(
    "cod-bank/create",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await DataService.post('/cod-bank', data);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }  
)

export const updateCodBank = createAsyncThunk(
    "cod-bank/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await DataService.patch('/cod-bank/' + id, data);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }  
)

export const deleteCodBank = createAsyncThunk(
    "cod-bank/delete",
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await DataService.delete('/cod-bank/' + id);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }  
)